import React, { useEffect, useState } from "react";
import useAuth from "./../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import "./BackupTable.css";
import SideBar from "./../../base-components/SideBar";
import SettingsBar from "./../../base-components/SideBar/Settings";
import Header from "./../../base-components/Header";
import { doPost } from "../../utils/apiCalls";
import { toast } from "react-toastify";
import Loader from "../../base-components/loader";
import { FaTrashAlt, FaUndo, FaCloudDownloadAlt } from "react-icons/fa";

const ConfirmationModal = ({
  show,
  onConfirm,
  onCancel,
  actionType,
  Reportsloading,
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{`Are you sure you want to ${actionType} this backup?`}</h3>
        <div className="modal-actions">
          <button
            disabled={Reportsloading}
            className="confirm-button"
            onClick={onConfirm}
          >
            {Reportsloading ? <Loader /> : "Yes"}
          </button>
          <button
            disabled={Reportsloading}
            className="cancel-button"
            onClick={onCancel}
          >
            {Reportsloading ? <Loader /> : "No"}
          </button>
        </div>
      </div>
    </div>
  );
};

function BackUps() {
  const navigate = useNavigate();
  const { getLoggedObject } = useAuth();
  const [loading, setLoading] = useState(false);
  const [Reportsloading, setReportsloading] = useState(false);
  const [backups, setBackups] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBackup, setSelectedBackup] = useState(null);
  const [actionType, setActionType] = useState("");

  const TakeBackups = async () => {
    const payload = {
      token: getLoggedObject()?.token,
    };
    setReportsloading(true);
    const { isError, data } = await doPost(
      payload,
      "Auth/backup_and_upload_tables"
    );
    if (isError) {
      toast.error("Something went wrong with server.");
      setReportsloading(false);
    } else {
      if (data.action) {
        toast.success("Backup taken successfully");
        setReportsloading(false);
        GetAllBackups();
      } else {
        setReportsloading(false);
        toast.error(data?.error);
      }
    }
  };

  const GetAllBackups = async () => {
    const payload = {
      token: getLoggedObject()?.token,
    };
    setReportsloading(true);
    const { isError, data } = await doPost(payload, "Auth/getDbBackups");
    if (isError) {
      toast.error("Something went wrong with server.");
      setReportsloading(false);
    } else {
      if (data.action) {
        setReportsloading(false);
        setBackups(data?.data);
      } else {
        setReportsloading(false);
        toast.error(data?.error);
      }
    }
  };

  const handleAction = (id, action) => {
    setSelectedBackup(id);
    setActionType(action);
    setShowModal(true);
  };

  const confirmAction = async () => {
    const payload = {
      token: getLoggedObject()?.token,
    };

    if (actionType === "delete") {
      setReportsloading(true);
      const { isError, data } = await doPost(
        payload,
        `Auth/deleteDbBackup/${selectedBackup}`
      );
      if (isError) {
        toast.error("Something went wrong with server.");
        setReportsloading(false);
      } else {
        toast.success("Backup deleted successfully");
        setReportsloading(false);
        setShowModal(false);
        GetAllBackups();
      }
    } else if (actionType === "restore") {
      setReportsloading(true);
      const { isError, data } = await doPost(
        payload,
        `Auth/restoreDB/${selectedBackup}`
      );
      if (isError) {
        toast.error("Something went wrong with server.");
        setReportsloading(false);
      } else {
        toast.success("Backup restored successfully");
        setReportsloading(false);
        setShowModal(false);
        navigate("/products");
      }
    }
  };

  const cancelAction = () => {
    setShowModal(false);
  };

  const DownloadBackup = async (id) => {
    const payload = {
      token: getLoggedObject()?.token,
    };
    setReportsloading(true);
    const { isError, data } = await doPost(
      payload,
      `Auth/downloadDbBackups/${id}`
    );
    if (isError) {
      toast.error("Something went wrong with server.");
      setReportsloading(false);
    } else {
      if (data.message == "success") {
        toast.success("Downloaded Successfully");
        const downloadLink = document.createElement("a");
        downloadLink.href = data.data;
        downloadLink.target = "_blank";
        downloadLink.download = data?.data;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setReportsloading(false);
      } else {
        setReportsloading(false);
        toast.error(data?.error);
      }
    }
  };

  useEffect(() => {
    GetAllBackups();
  }, []);

  return (
    <div className="container">
      <div className="wrapper-full">
        <div className="page-content">
          <SideBar />
          <div className="right_side_bar">
            <Header title={"Backups"} />
            <div className="content_inner">
              <div className="content_settings">
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <SettingsBar />
                    <div className="right_settings_box">
                      <h1 style={{ marginBottom: "10px" }}>Backups</h1>
                      <div className="card wd100 mt-10px p10">
                        <div className="p10 ReportsBox">
                          <h3>Take Backups</h3>
                          <button
                            style={{ backgroundColor: "#5ca399" }}
                            onClick={TakeBackups}
                            disabled={Reportsloading}
                          >
                            {Reportsloading ? <Loader /> : "Backup Now"}
                          </button>
                        </div>
                      </div>
                      <div className="table-wrapper">
                        <h2 className="table-title">Backup Data</h2>
                        <table className="styled-table">
                          <thead>
                            <tr>
                              <th>File Name</th>
                              <th>Created At</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {backups.length > 0 ? (
                              backups.map((backup, index) => (
                                <tr key={backup.id}>
                                  <td>{"Backup" + (index + 1)}</td>
                                  <td>{backup.created_at}</td>
                                  <td className="MainActionTable">
                                    <button
                                      disabled={Reportsloading}
                                      className="Restore-action-button"
                                      onClick={() =>
                                        handleAction(backup.id, "restore")
                                      }
                                    >
                                      {Reportsloading ? <Loader /> : <FaUndo />}{" "}
                                      Restore
                                    </button>
                                    <button
                                      disabled={Reportsloading}
                                      className="action-button"
                                      onClick={() => DownloadBackup(backup.id)}
                                    >
                                      {Reportsloading ? (
                                        <Loader />
                                      ) : (
                                        <FaCloudDownloadAlt />
                                      )}{" "}
                                      Download
                                    </button>
                                    <button
                                      disabled={Reportsloading}
                                      className="Delete-action-button"
                                      onClick={() =>
                                        handleAction(backup.id, "delete")
                                      }
                                    >
                                      {Reportsloading ? (
                                        <Loader />
                                      ) : (
                                        <FaTrashAlt />
                                      )}{" "}
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                  No Backups Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={showModal}
        actionType={actionType}
        onConfirm={confirmAction}
        onCancel={cancelAction}
        Reportsloading={Reportsloading}
      />
    </div>
  );
}

export default BackUps;
